import React, { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";

import ReelContainer from "./components/ReelContainer";
import Container from "Components/Container/Container";
import backgroud from "assests/bghomd.png";
import useButtonConfig from "Hooks/useButtonConfig";

const Reels = ({ trending }) => {
  const [activeIndex, setActiveIndex] = useState(0);
  const [isLargeScreen, setIsLargeScreen] = useState(false);

  const { t } = useTranslation();
  const navigate = useNavigate();
  const buttonConfig = useButtonConfig();
  const reelsData = trending?.reels || [];

  useEffect(() => {
    const checkScreenSize = () => {
      setIsLargeScreen(window.innerWidth >= 768);
    };
    checkScreenSize();
    window.addEventListener("resize", checkScreenSize);
    return () => window.removeEventListener("resize", checkScreenSize);
  }, []);

  const scrollToIndex = (index) => {
    const reelContainer = document.querySelector(".reel-item");
    if (reelContainer) {
      const itemHeight = reelContainer.offsetHeight;
      document.querySelector(".scrollbar-hide").scrollTo({
        top: index * itemHeight,
        behavior: "smooth",
      });
    }
  };

  if (!reelsData || reelsData.length === 0) return null;

  return (
    <section className="relative overflow-hidden" id="reels-section">
      {/* Background image — desktop only */}
      <div className="absolute inset-0">
        <img
          src={backgroud}
          alt="background"
          className="w-full h-full hidden lg:block"
        />
      </div>

      {/* Desktop Layout — side by side */}
      <div className="hidden lg:block relative z-10">
        <div className="container mx-auto px-4 grid grid-cols-1 lg:grid-cols-2 gap-6 lg:gap-12 items-center relative z-10">
          <div className="flex-1">
            <div className="mb-section-title-gap-lg">
              <h2 className="text-start text-2xl sm:text-4xl md:text-5xl lg:text-6xl uppercase font-bold text-white mb-section-title-gap drop-shadow-lg">
                {trending?.title || t("home.featured_reels")}
              </h2>
              <p className="text-start text-base text-gray-300 max-w-2xl whitespace-pre-line">
                {trending?.text || t("home.reels_description")}
              </p>
              <div className="mt-section-title-gap-lg flex flex-row items-center gap-4">
                <button
                  onClick={buttonConfig.action}
                  className="bg-primary hover:bg-darkPrimary text-white px-8 py-3 rounded-lg font-semibold transition-colors duration-300"
                >
                  {buttonConfig.text}
                </button>
                <button
                  onClick={() => navigate("/categories")}
                  className="border border-primary text-white px-8 py-3 rounded-lg font-semibold hover:bg-darkPrimary transition-colors duration-300"
                >
                  {t("general.view_all_categories")}
                </button>
              </div>
            </div>
          </div>

          <div className="flex-1">
            <div className="w-full lg:w-3/4 mx-auto">
              <ReelContainer
                reelsData={reelsData}
                activeIndex={activeIndex}
                setActiveIndex={setActiveIndex}
                isLargeScreen={isLargeScreen}
                scrollToIndex={scrollToIndex}
              />
            </div>
          </div>
        </div>
      </div>

      {/* Mobile Layout — stacked, contained */}
      <div className="lg:hidden relative z-10">
        <Container>
          <div className="text-center mb-section-title-gap lg:mb-section-title-gap-lg">
            <h2 className="text-2xl sm:text-3xl uppercase font-bold text-white mb-section-title-gap drop-shadow-lg">
              {trending?.title || t("home.featured_reels")}
            </h2>
            <p className="text-sm sm:text-base text-gray-300 whitespace-pre-line">
              {trending?.text || t("home.reels_description")}
            </p>
          </div>

          {/* Reel player — centered, constrained width */}
          <div className="w-full sm:max-w-sm mx-auto">
            <ReelContainer
              reelsData={reelsData}
              activeIndex={activeIndex}
              setActiveIndex={setActiveIndex}
              isLargeScreen={isLargeScreen}
              scrollToIndex={scrollToIndex}
            />
          </div>

          {/* CTA buttons */}
          <div className="mt-section-title-gap lg:mt-section-title-gap-lg flex flex-col sm:flex-row items-center justify-center gap-3">
            <button
              onClick={buttonConfig.action}
              className="w-full sm:w-auto bg-primary hover:bg-darkPrimary text-white px-8 py-3 rounded-lg font-semibold transition-colors duration-300"
            >
              {buttonConfig.text}
            </button>
            <button
              onClick={() => navigate("/categories")}
              className="w-full sm:w-auto border border-primary text-white px-8 py-3 rounded-lg font-semibold hover:bg-darkPrimary transition-colors duration-300"
            >
              {t("general.view_all_categories")}
            </button>
          </div>
        </Container>
      </div>
    </section>
  );
};

export default Reels;
